import styled from "@emotion/styled";
import { Button } from "../Button/Button";

const UnderlinedButtonStyle = styled(Button)`
  text-decoration: underline;
  text-underline-offset: 5px;
  padding: 0;
`;

const Row = styled.div`
  display: flex;
`;

export { Row, UnderlinedButtonStyle };
